// No `toJSON()`: the archival endpoint carries no body, on the `DELETE` side too.
class RestoreDocumentType {
	constructor(
		public readonly accountId: number,
		public readonly documentTypeId: number,
	) {
		Object.freeze(this);
	}
}

export default RestoreDocumentType;
